import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconDocument = props => (
  <SvgIcon {...props} viewBox="0 0 16 20">
    <path d="m10 0h-8c-1.1 0-1.99 0.9-1.99 2l-0.01 16c0 1.1 0.89 2 1.99 2h12.01c1.1 0 2-0.9 2-2v-12l-6-6zm2 16h-8v-2h8v2zm0-4h-8v-2h8v2zm-3-5v-5.5l5.5 5.5h-5.5z" />
  </SvgIcon>
);

export default IconDocument;



// WEBPACK FOOTER //
// ./src/components/icons/IconDocument.js